// Studyo Today Backend
// Package studyo.today.demo.v1
// Service definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/demo/v1/demo.proto (package studyo.today.demo.v1, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_demo_v1_resources_snapshot } from "./resources/snapshot_pb.js";

/**
 * Describes the file studyo/today/demo/v1/demo.proto.
 */
export const file_studyo_today_demo_v1_demo = /*@__PURE__*/
  fileDesc("Ch9zdHVkeW8vdG9kYXkvZGVtby92MS9kZW1vLnByb3RvEhRzdHVkeW8udG9kYXkuZGVtby52MSJCCh9DcmVhdGVEZW1vU2Nob29sU25hcHNob3RSZXF1ZXN0EhEKCXNjaG9vbF9pZBgBIAEoCRIMCgRuYW1lGAIgASgJIngKIENyZWF0ZURlbW9TY2hvb2xTbmFwc2hvdFJlc3BvbnNlEhEKCXNjaG9vbF9pZBgBIAEoCRITCgtwbGFubmVyX2lkcxgCIAMoCRIQCgh1c2VyX2lkcxgDIAMoCRIaChJzY2hlZHVsZV9jeWNsZV9pZHMYBCADKAkiVwogUmVzdG9yZURlbW9TY2hvb2xTbmFwc2hvdFJlcXVlc3QSEQoJc2Nob29sX2lkGAEgASgJEgwKBG5hbWUYAiABKAkSEgoKZGF5X29mZnNldBgDIAEoBSIzCh5MaXN0RGVtb1NjaG9vbFNuYXBzaG90c1JlcXVlc3QSEQoJc2Nob29sX2lkGAEgASgJIl4KH0xpc3REZW1vU2Nob29sU25hcHNob3RzUmVzcG9uc2USOwoJc25hcHNob3RzGAEgAygLMiguc3R1ZHlvLnRvZGF5LmRlbW8udjEucmVzb3VyY2VzLlNuYXBzaG90Mo4DCgREZW1vEosBChhDcmVhdGVEZW1vU2Nob29sU25hcHNob3QSNS5zdHVkeW8udG9kYXkuZGVtby52MS5DcmVhdGVEZW1vU2Nob29sU25hcHNob3RSZXF1ZXN0GjYuc3R1ZHlvLnRvZGF5LmRlbW8udjEuQ3JlYXRlRGVtb1NjaG9vbFNuYXBzaG90UmVzcG9uc2UiABJtChlSZXN0b3JlRGVtb1NjaG9vbFNuYXBzaG90EjYuc3R1ZHlvLnRvZGF5LmRlbW8udjEuUmVzdG9yZURlbW9TY2hvb2xTbmFwc2hvdFJlcXVlc3QaFi5nb29nbGUucHJvdG9idWYuRW1wdHkiABKIAQoXTGlzdERlbW9TY2hvb2xTbmFwc2hvdHMSNC5zdHVkeW8udG9kYXkuZGVtby52MS5MaXN0RGVtb1NjaG9vbFNuYXBzaG90c1JlcXVlc3QaNS5zdHVkeW8udG9kYXkuZGVtby52MS5MaXN0RGVtb1NjaG9vbFNuYXBzaG90c1Jlc3BvbnNlIgBCHKoCGVN0dWR5by5Ub2RheS5EZW1vLkdycGMuVjFiBnByb3RvMw", [file_google_protobuf_empty, file_studyo_today_demo_v1_resources_snapshot]);

/**
 * Describes the message studyo.today.demo.v1.CreateDemoSchoolSnapshotRequest.
 * Use `create(CreateDemoSchoolSnapshotRequestSchema)` to create a new message.
 */
export const CreateDemoSchoolSnapshotRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_demo_v1_demo, 0);

/**
 * Describes the message studyo.today.demo.v1.CreateDemoSchoolSnapshotResponse.
 * Use `create(CreateDemoSchoolSnapshotResponseSchema)` to create a new message.
 */
export const CreateDemoSchoolSnapshotResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_demo_v1_demo, 1);

/**
 * Describes the message studyo.today.demo.v1.RestoreDemoSchoolSnapshotRequest.
 * Use `create(RestoreDemoSchoolSnapshotRequestSchema)` to create a new message.
 */
export const RestoreDemoSchoolSnapshotRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_demo_v1_demo, 2);

/**
 * Describes the message studyo.today.demo.v1.ListDemoSchoolSnapshotsRequest.
 * Use `create(ListDemoSchoolSnapshotsRequestSchema)` to create a new message.
 */
export const ListDemoSchoolSnapshotsRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_demo_v1_demo, 3);

/**
 * Describes the message studyo.today.demo.v1.ListDemoSchoolSnapshotsResponse.
 * Use `create(ListDemoSchoolSnapshotsResponseSchema)` to create a new message.
 */
export const ListDemoSchoolSnapshotsResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_demo_v1_demo, 4);

/**
 * API definition for the Today Demo Service.
 *
 * @generated from service studyo.today.demo.v1.Demo
 */
export const Demo = /*@__PURE__*/
  serviceDesc(file_studyo_today_demo_v1_demo, 0);

